import { render, staticRenderFns } from "./ModalPromotionBrandTable.vue?vue&type=template&id=d32533be&scoped=true&"
import script from "./ModalPromotionBrandTable.vue?vue&type=script&lang=js&"
export * from "./ModalPromotionBrandTable.vue?vue&type=script&lang=js&"
import style0 from "./ModalPromotionBrandTable.vue?vue&type=style&index=0&id=d32533be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32533be",
  null
  
)

export default component.exports